// removed by extract-text-webpack-plugin
module.exports = {"container":"autosuggest-theme__container__X6nwB","suggestionsContainer":"autosuggest-theme__suggestionsContainer__rgcBd"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/autosuggest-theme.scss
// module id = 644
// module chunks = 0